"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CopyToClipboard = CopyToClipboard;

var _reactCopyToClipboard = require("react-copy-to-clipboard");

var _iconButton = require("./buttons/icon-button");

var _typography = require("./typography");

var _styles = require("react-components/styles");

var _styledTools = require("styled-tools");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _excluded = ["colorTheme", "copiedLabel", "className", "icon", "iconSize", "size", "value"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var copyIcon = "<svg width=\"16\" height=\"16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path stroke=\"currentColor\" stroke-miterlimit=\"10\" d=\"M12.31 10.44V5.71a2.35 2.35 0 00-.8-1.77l-.63-.55a2.35 2.35 0 00-1.56-.59H4.16a2.37 2.37 0 00-1.56.59l-.6.55a2.35 2.35 0 00-.8 1.77v6.38a2.35 2.35 0 00.8 1.77l.63.55a2.37 2.37 0 001.53.59h5.16c.575 0 1.13-.21 1.56-.59l.63-.55a2.35 2.35 0 00.8-1.77v-1.65z\"/><path stroke=\"currentColor\" stroke-miterlimit=\"10\" d=\"M13.4 12.61l.63-.55a2.35 2.35 0 00.8-1.77V3.91A2.35 2.35 0 0014 2.14l-.63-.55A2.37 2.37 0 0011.84 1H6.68c-.575 0-1.13.21-1.56.59l-.63.55\"/></svg>";

/**
 * `Wrapper` styled component.
 */
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "copy-to-clipboard__Wrapper",
  componentId: "sc-z0ep84-0"
})(["display:flex;position:relative;"]);
/**
 * `Notification` styled component.
 */


var Notification = (0, _styledComponents["default"])(_typography.Text).attrs({
  as: 'span',
  size: 'small'
}).withConfig({
  displayName: "copy-to-clipboard__Notification",
  componentId: "sc-z0ep84-1"
})(["animation:0.5s linear forwards;background-color:", ";border-radius:", "px;bottom:-32px;color:", ";left:50%;opacity:0;padding:4px 8px;position:absolute;transform:translateX(-50%);", ""], (0, _styles.color)('gray400'), (0, _styledTools.theme)('dimensions.borderRadius'), (0, _styles.color)('white'), (0, _styledTools.ifProp)('isVisible', (0, _styledComponents.css)(["animation-name:", ";"], (0, _styledTools.theme)('keyframes.fadeIn')), (0, _styledComponents.css)(["animation-name:", ";"], (0, _styledTools.theme)('keyframes.fadeOut'))));
/**
 * Export `CopyToClipboard` component.
 */

function CopyToClipboard(props) {
  var _props$colorTheme = props.colorTheme,
      colorTheme = _props$colorTheme === void 0 ? 'transparent' : _props$colorTheme,
      copiedLabel = props.copiedLabel,
      className = props.className,
      _props$icon = props.icon,
      icon = _props$icon === void 0 ? copyIcon : _props$icon,
      _props$iconSize = props.iconSize,
      iconSize = _props$iconSize === void 0 ? 'small' : _props$iconSize,
      _props$size = props.size,
      size = _props$size === void 0 ? '16px' : _props$size,
      value = props.value,
      buttonProps = _objectWithoutProperties(props, _excluded);

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      copyCount = _useState2[0],
      setCopyCount = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isVisible = _useState4[0],
      setVisible = _useState4[1];

  var handleCopy = (0, _react.useCallback)(function () {
    setCopyCount(function (count) {
      return (count + 1) % 100;
    });
    setVisible(true);
  }, []);
  (0, _react.useEffect)(function () {
    if (copyCount <= 0) {
      return;
    }

    var timeout = setTimeout(function () {
      setVisible(false);
    }, 2000);
    return function () {
      return clearTimeout(timeout);
    };
  }, [copyCount]);
  (0, _react.useEffect)(function () {
    if (!isVisible) {
      var timeout = setTimeout(function () {
        setCopyCount(0);
      }, 500);
      return function () {
        return clearTimeout(timeout);
      };
    }
  }, [isVisible]);
  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_reactCopyToClipboard.CopyToClipboard, {
    onCopy: handleCopy,
    text: value
  }, /*#__PURE__*/_react["default"].createElement(_iconButton.IconButton, _extends({}, buttonProps, {
    colorTheme: colorTheme,
    icon: icon,
    iconSize: iconSize,
    size: size
  }))), copyCount > 0 && /*#__PURE__*/_react["default"].createElement(Notification, {
    "aria-hidden": !isVisible,
    isVisible: isVisible
  }, copiedLabel));
}